import CharacterCounter from './component.jsx'
export default CharacterCounter
